import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

// import DandDCharacterUtilities from '../../../utilities/character_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
// import DeleteButton from '../../../../../components/input/buttons/DeleteButton';

interface Props {
  character: Character;
}

// const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterTransformInput({
  character,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  // const [expanded, setExpanded] = useState("");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="header centered"
        size={12}>Transforms &amp; Adaptations</Grid>
      { character.transform &&
        <>
          <Grid size={12}>
            <ToggleButtonBox
              name={`Show ${character.transform.transform?.name??"Transform"}`}
              disabled={processing}
              value={character.use_transform}
              onToggle={() => {
                character.use_transform = !character.use_transform;
                character.changed();
                character.subscription_holder.transformed();
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <ToggleButtonBox
              name="End Transform"
              value={false}
              disabled={processing}
              onToggle={() => {
                character.transform = null;
                character.use_transform = false;
                character.changed();
                character.subscription_holder.transformed();
                setProcessing(true);
              }}
            />
          </Grid>
          {/* { !reloading && character.transform.adaptations.map((adaptation, key) => {
            return (
              <Grid item xs={12} key={key} container spacing={0} direction="row">
                <Grid item xs={9} className="header clickable" onClick={() => {
                  setExpanded(adaptation.true_id);
                }}>
                  { adaptation.name }
                </Grid>
                <Grid item xs={3}>
                  { adaptation.cf_id === "" &&
                    <DeleteButton
                      disabled={processing}
                      onClick={() => {
                        const transform = character.transform;
                        if (transform) {
                          transform.adaptations = transform.adaptations.filter(o => o.true_id !== adaptation.true_id);
                          setProcessing(true);
                          char_util.removeAdaptation(character, adaptation).then(() => {
                            setProcessing(false);
                            setReloading(true);
                            onChange();
                          });
                        }
                      }}
                    />
                  }
                </Grid>
                { expanded === adaptation.true_id &&
                  <Grid item xs={12}>
                    { adaptation.description }
                  </Grid>
                }
              </Grid>
            );
          })} */}
        </>
      }
    </Grid>
  );
}
